import numeral from 'numeral';
export const transactionSalesDetailsConfig = {
  salesPrice: {
    label: 'Sale price',
    apiKeyPath: 'purchaseDetails.purchasePrice',
    format: amount => numeral(amount).format('$0,0.00')
  },
  atlassianFee: {
    label: 'Atlassian fee',
    condition: transaction => numeral(transaction.purchaseDetails.purchasePrice - transaction.purchaseDetails.vendorAmount).format('$0,0.00')
  },
  totalRevenue: {
    label: 'Net revenue',
    apiKeyPath: 'purchaseDetails.vendorAmount',
    format: amount => numeral(amount).format('$0,0.00')
  }
};
export const transactionDetailsConfig = [{
  head: 'CUSTOMER INFORMATION',
  content: [{
    label: 'Company',
    apiKeyPath: 'customerDetails.company'
  }, {
    label: 'Country',
    apiKeyPath: 'customerDetails.country'
  }, {
    label: 'Region',
    apiKeyPath: 'customerDetails.region'
  }]
}, {
  head: 'MAINTENANCE PERIOD',
  content: [{
    label: 'Start date',
    apiKeyPath: 'purchaseDetails.maintenanceStartDate'
  }, {
    label: 'End date',
    apiKeyPath: 'purchaseDetails.maintenanceEndDate'
  }]
}, {
  head: 'CUSTOMER CONTACT',
  content: [{
    label: 'Billing contact name',
    apiKeyPath: 'customerDetails.billingContact.name'
  }, {
    label: 'Billing contact email',
    apiKeyPath: 'customerDetails.billingContact.email'
  }, {
    label: 'Technical contact name',
    apiKeyPath: 'customerDetails.technicalContact.name'
  }, {
    label: 'Technical contact email',
    apiKeyPath: 'customerDetails.technicalContact.email'
  }]
}, {
  head: 'REVENUE',
  content: [{
    label: 'Sale price',
    apiKeyPath: 'purchaseDetails.purchasePrice',
    format: amount => numeral(amount).format('$0,0.00')
  }, {
    label: 'Atlassian fee',
    condition: transaction => numeral(transaction.purchaseDetails.purchasePrice - transaction.purchaseDetails.vendorAmount).format('$0,0.00')
  }, {
    label: 'Net revenue',
    apiKeyPath: 'purchaseDetails.vendorAmount',
    format: amount => numeral(amount).format('$0,0.00')
  }]
}, {
  head: 'SALE DETAILS',
  content: [{
    label: 'Sale date',
    apiKeyPath: 'purchaseDetails.saleDate'
  }, {
    label: 'Sale type',
    apiKeyPath: 'purchaseDetails.saleType'
  }, {
    label: 'Net revenue',
    apiKeyPath: 'purchaseDetails.vendorAmount',
    format: amount => numeral(amount).format('$0,0.00')
  }, {
    label: 'Order ID',
    apiKeyPath: 'transactionId'
  }, {
    label: 'Addon license ID',
    apiKeyPath: 'addonLicenseId',
    hideOnNull: true
  }, {
    label: 'Host license ID',
    apiKeyPath: 'hostLicenseId',
    hideOnNull: true
  }, {
    label: 'License ID',
    apiKeyPath: 'licenseId',
    hideOnNull: true
  }, {
    label: 'Entitlement number',
    apiKeyPath: 'appEntitlementNumber',
    hideOnNull: true
  }, {
    label: 'Host entitlement number',
    apiKeyPath: 'hostEntitlementNumber',
    hideOnNull: true
  }, {
    label: 'App entitlement number',
    apiKeyPath: 'appEntitlementNumber',
    hideOnNull: true
  }, {
    label: 'Cloud ID',
    apiKeyPath: 'cloudId',
    hideOnNull: true
  }, {
    label: 'App name',
    apiKeyPath: 'addonName'
  }, {
    label: 'App key',
    apiKeyPath: 'addonKey'
  }, {
    label: 'Hosting',
    apiKeyPath: 'purchaseDetails.hosting'
  }, {
    label: 'Tier',
    apiKeyPath: 'purchaseDetails.tier'
  }, {
    label: 'Billing period',
    apiKeyPath: 'purchaseDetails.billingPeriod'
  }]
}, {
  head: 'SALE CHANNEL',
  content: [{
    label: 'Sold By',
    condition: transaction => transaction.partnerDetails ? 'Partner/ Re-seller' : 'Direct'
  }, {
    conditionalFieldCheck: transaction => transaction.partnerDetails || false,
    label: 'Partner name',
    apiKeyPath: 'partnerDetails.partnerName'
  }, {
    conditionalFieldCheck: transaction => transaction.partnerDetails || false,
    label: 'Partner type',
    apiKeyPath: 'partnerDetails.partnerType'
  }, {
    conditionalFieldCheck: transaction => transaction.partnerDetails || false,
    label: 'Billing contact name',
    apiKeyPath: 'partnerDetails.billingContact.name'
  }, {
    conditionalFieldCheck: transaction => transaction.partnerDetails || false,
    label: 'Billing contact email',
    apiKeyPath: 'partnerDetails.billingContact.email'
  }]
}];